// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__UEJN9","breadcrumbsItem":"breadcrumbs_breadcrumbsItem__ezAV_","isPrivateArea":"breadcrumbs_isPrivateArea__7GLZX"};